module.exports = __webpack_public_path__ + "static/media/elephant_right_sobel-min.4fff9624.jpg";